exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "a{text-decoration:none}", "", {"version":3,"sources":["/home/circleci/repo/app/src/app.vue"],"names":[],"mappings":"AA2BA,EACE,oBAAA,CAAA","file":"app.vue?vue&type=style&index=0&lang=sass&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\na\n  text-decoration: none\n"],"sourceRoot":""}]);

// exports
